module.exports = __webpack_public_path__ + "img/logo-success9.124fd13b.jpg";